// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oC-z","smallCardRow":"pC-z","largeCardRow":"qC-z","productSearchRow":"rC-z","curatedRow":"sC-z"};